// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Bt8p","right":"styles_right__2vcUU"};